// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"59885826","703":"bea65ffd","787":"d13fc932"}[chunkId] + ".chunk.js";
};